module.exports = __webpack_public_path__ + "img/icon--dashboard.bbc34468.svg";